module.exports = __webpack_public_path__ + "a5c2134d2af023f84ec33841d42a9875.jpg";